import { toast } from 'react-toastify'
import axios from 'axios'
import { MAIN_URL } from './GeneralVariables'
import { apiErrorHandler } from './errorHandling'

let authToken = localStorage.getItem('Token')
export const getData = async (
  url,
  type,
  dataParams = {},
  isToken = false,
  isHeaderJson = false,
  default_token = null
) => {
  let header = {}
  if (isToken && default_token) {
    header = { headers: { Authorization: `Bearer ${default_token}` } }
    if (isHeaderJson) {
      header = {
        headers: {
          'Access-Control-Allow-Origin': 'http://localhost:3000',
          'Access-Control-Allow-Credentials': 'true',
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${default_token}`,
          Accept: '*/*',
          // "Accept-Encoding": "gzip, deflate, br",
          // "Access-Control-Allow-Origin" : "*/*",
          // Connection: "keep-alive"
        },
      }
    }
  } else if (isToken) {
    header = {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
    }
    if (isHeaderJson) {
      header = {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${authToken}`,
          Accept: '*/*',
          // "Accept-Encoding": "gzip, deflate, br",
          'Access-Control-Allow-Origin': '*/*',
          // 'Access-Control-Allow-Origin':'http://localhost:3000',
          'Access-Control-Allow-Credentials': 'true',
          // Connection: "keep-alive"
        },
      }
    }
  }

  if (type === 'post') {
    let formData
    if (isHeaderJson) {
      formData = dataParams
    } else {
      formData = new URLSearchParams()
      for (let key in dataParams) {
        formData.append(key, dataParams[key])
      }
    }
    try {
      const { data, status } = isToken
        ? await axios.post(MAIN_URL + url, formData, header)
        : await axios.post(MAIN_URL + url, formData)
      if (status === 200) {
        for (let key in data.messages) {
          toast.success(data.messages[key])
        }
        return { status: status, data: data }
      }
    } catch (e) {
      return apiErrorHandler(e, default_token)
    }
  } else {
    let formData = '?'

    if (Object.keys(dataParams).length === 0 && dataParams.constructor === Object) {
      formData = ''
    }
    for (let key in dataParams) {
      formData +=
        formData.slice(-1) === '?' ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`
    }

    try {
      const { data, status } = isToken
        ? await axios.get(MAIN_URL + url + formData, header)
        : await axios.get(MAIN_URL + url + formData)
      if (status === 200) {
        for (let key in data.messages) {
          toast.success(data.messages[key])
        }
        return { status: status, data: data }
      } else {
        toast.error('خطای ناخواسته ای پیش آمد')
        return false
      }
    } catch (e) {
      return apiErrorHandler(e, default_token)
    }
  }
}

export const priceFormat = (price) => {
  return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const edit_item_with_id = (lastItems, editItem) => {
  return lastItems.map((item) => {
    if (parseInt(item?.id) === parseInt(editItem?.id)) {
      return { ...editItem }
    } else {
      return { ...item }
    }
  })
}

export const remove_item_of_arr_with_id = (arr, id) => {
  let new_array = []
  arr.map((itm) => {
    if (id !== itm.id) {
      new_array.push(itm)
    }
  })
  return new_array
}

// remove Swal
// const swalWithBootstrapButtons = Swal.mixin({
//     customClass: {
//         confirmButton: 'btn btn-success',
//         cancelButton: 'btn btn-danger'
//     },
//     buttonsStyling: false
// })
// swalWithBootstrapButtons.fire({
//     title: 'آیا مطمئن هستید؟',
//     text: "میخواهید این مورد را حذف کنید",
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonText: 'بله حذف کن',
//     cancelButtonText: 'نه حذف نشود',
//     reverseButtons: true
// }).then(async (result) => {
//     if (result.isConfirmed) {
//         let remove_result = await getData(MAIN_URL, `account/portfolio/remove/${id}`, 'get', {}, token, false);
//         if (remove_result?.status === 200) {
//             swalWithBootstrapButtons.fire(
//                 'حذف شد!',
//                 'با موفقیت حذف شد',
//                 'success'
//             )
//             setRender(!is_render)
//         }
//     } else if (
//         /* Read more about handling dismissals below */
//         result.dismiss === Swal.DismissReason.cancel
//     ) {
//         swalWithBootstrapButtons.fire(
//             'لغو شد',
//             'بدون تغییر باقی ماند',
//             'error'
//         )
//     }
// })

// success Swal
// Swal.fire({
//     position: 'top-end',
//     icon: 'success',
//     title: 'Your work has been saved',
//     showConfirmButton: false,
//     timer: 1500
// })

export const notAllowEnterNumber = (e, count) => {
  let currentNumber = `${e.target.value}`
  currentNumber.length === count && e.preventDefault()
}
